import MUIExpandMore from '@mui/icons-material/ExpandMore'

export const ChevronUp = MUIExpandMore
